import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/local/environment';
import { L1L3AuthService } from 'ngx-auth-util-lib';
import { Router } from '@angular/router';
import { ERROR_CODES } from '../../models/codes';
// import { CompanyDataMgmtService } from '../companydatamgmt.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  constructor(
    private translateService: TranslateService,
    private authService: L1L3AuthService,
    private router: Router
  ) {}

  getClientMessage(error: Error): string {
    if (!navigator.onLine) {
      return this.translateService.instant('ERRORS.NO_INTERNET');
    }
    if (environment.production) {
      return this.translateService.instant('ERRORS.UNEXPECTED_CLIENT_ERROR');
    }
    return error.message ? error.message : error.toString();
  }

  getClientStack(error: Error): string | undefined {
    return error.stack;
  }

  getServerMessage(error: HttpErrorResponse): string | null {
    return this.generateHttpResponseErrorMessage(error);
  }

  getServerStack(error: HttpErrorResponse): string {
    // handle stack trace
    return 'stack';
  }

  generateHttpResponseErrorMessage(err: HttpErrorResponse): string | null {
    let errorMessage: string | null = '';
    if (err.status) {
      switch (err.status) {
        case 400:
          if (err.error?.code) {
            errorMessage = this.handle400Errors(err);
          }
          break;
        case 401:
          errorMessage = this.translateService.instant('ERRORS.NO_PERMISSION');
          break;
        case 403:
          errorMessage = this.translateService.instant('ERRORS.NO_PERMISSION');
          break;
        case 500:
          errorMessage = this.translateService.instant('ERRORS.INTERNAL_SERVER_ERROR');
          break;
        case 503:
          errorMessage = this.translateService.instant('ERRORS.PERSISTENCE_NOT_AVAILABLE');
          break;
      }
    }
    if (!errorMessage) {
      errorMessage = this.translateService.instant('ERRORS.UNEXPECTED_ERROR');
    }
    return errorMessage;
  }

  createUnknownCodeMessage(error: HttpErrorResponse): string {
    let message = this.translateService.instant('ERRORS.UNEXPECTED_ERROR');
    let code = '';
    if (error.status) {
      code = 'Code: ';
      if (error.status === 400 && error.error?.code) {
        code = code + error.error.code;
      } else {
        code = code + error.status;
      }
      message = message + ' ' + code;
    }
    return message;
  }

  private isSecuredHost(url: string): boolean {
    return this.authService.securedHosts.some(n => url.includes(n));
  }

  private handle400Errors(err: HttpErrorResponse): string {
    let errorMessage = '';
    switch (err.error.code) {
      case ERROR_CODES.ORDER_NOT_FOUND:
        errorMessage = this.translateService.instant('ERRORS.ORDER_NOT_FOUND');
        break;
      case ERROR_CODES.COMPANY_DATA_NOT_FOUND:
        errorMessage = this.translateService.instant('ERRORS.COMPANY_DATA_NOT_FOUND');
        break;
      case ERROR_CODES.OMS_KEY_ENTRY_NOT_FOUND:
        errorMessage = this.translateService.instant('ERRORS.OMS_KEY_ENTRY_NOT_FOUND');
        break;
      case ERROR_CODES.KEY_IS_MAPPED_TO_COMPONENT:
        errorMessage = this.translateService.instant('ERRORS.KEY_IS_MAPPED_TO_COMPONENT');
        break;
      default:
        errorMessage = this.createUnknownCodeMessage(err);
        break;
    }
    return errorMessage;
  }
}
